import { Injectable } from '@angular/core';
import { ReferenceTableRepository, WorkspaceDatabaseKeys } from '@database/workspace';
import { SampleTypeProvider } from '@domain/business-layer';
import { QueryParamsProvider } from '@domain/routing';
import { FormActionTypeEnum, ReferenceTableModel } from '@shared';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TableTypeProvider } from '../../business-layer/services/table-type.provider';

@Injectable()
export class DropdownDataSourceProvider {
	public constructor(
		private queryParamsProvider: QueryParamsProvider,
		private sampleTypeProvider: SampleTypeProvider,
		private refTableRepository: ReferenceTableRepository,
		private tableTypeProvider: TableTypeProvider
	) {}

	public getReferenceTables(refTableName: string): Observable<ReferenceTableModel[]> {
		const formActionType: FormActionTypeEnum = this.queryParamsProvider.formActionType();
		const childtableName = this.queryParamsProvider.childTableName;
		const parentTableName = this.queryParamsProvider.parentTableName;
		// todo: use TableTypeProvider.getTableType()
		const isSampleTable$ = this.tableTypeProvider.isSampleTable$(childtableName ? childtableName : parentTableName);

		return isSampleTable$.pipe(
			switchMap((isSampleT: boolean) =>
				isSampleT &&
				WorkspaceDatabaseKeys.columns.dropdownsToSplitByQcOriginal.includes(refTableName.toLowerCase())
					? this.sampleTypeProvider.isQcSampleEntry$().pipe(
							switchMap((isQcSample: boolean) => {
								const qcMode = formActionType === FormActionTypeEnum.duplicate || isQcSample;
								// getReferenceTablesByCategory() expects as input a 'qcMode' boolean parameter
								// which in our case can be one of the two possibilities: dup mode when pressing on the dup icon
								// on an original sample or editing a qc sample, which is translated to 'isQcSample'
								return this.getReferenceTablesByCategory$(qcMode);
							})
					  )
					: this.refTableRepository.getAll(refTableName.toLowerCase())
			)
		);
	}

	public getReferenceTablesByCategory$(qcMode: boolean): Observable<ReferenceTableModel[]> {
		return qcMode
			? this.sampleTypeProvider.getGroupedByCategorySampleTypes$().pipe(
					map((groupedRefTables: { [key: string]: ReferenceTableModel[] } | null) => {
						if (!groupedRefTables[WorkspaceDatabaseKeys.referenceTables.qcCategory]) {
							return [];
						}
						return groupedRefTables[WorkspaceDatabaseKeys.referenceTables.qcCategory].sort((a, b) =>
							a[WorkspaceDatabaseKeys.referenceTables.assaySampleTypeCode]
								.toLowerCase()
								.localeCompare(
									b[WorkspaceDatabaseKeys.referenceTables.assaySampleTypeCode].toLowerCase()
								)
						);
					})
			  )
			: this.sampleTypeProvider.getGroupedByCategorySampleTypes$().pipe(
					map((groupedRefTables: { [key: string]: ReferenceTableModel[] }) => {
						if (!groupedRefTables[WorkspaceDatabaseKeys.referenceTables.originalCategory]) {
							return [];
						}
						return groupedRefTables[WorkspaceDatabaseKeys.referenceTables.originalCategory];
					})
			  );
	}
}
